import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { createCookie, getCookie } from '../../../utilities/backend-helpers/index.js';
import { disableBodyScroll, enableBodyScroll, handleTabKey } from '../../../utilities/behavior-helpers/index.js';
import '../../../utilities/dom-helpers/index.js';
import { setScrollTop } from '../../product-selector/utils/index.js';
import css_248z from './restricted-content.scss.js';

class RestrictedContent extends s {
    constructor() {
        super(...arguments);
        this.show = false;
        this.scrollTop = 0;
        this.tabsContainer = null;
        this.cookieName = 'AllowRestrictedContent';
        this.redirectUrl = '';
        this.tabId = '';
        this.hiddenBehindTabs = false;
        this.setPageContentFixed = (flag) => {
            if (flag) {
                disableBodyScroll();
                this.scrollTop = window.scrollY;
                document.body.style.position = 'fixed';
            }
            else {
                enableBodyScroll();
                document.body.style.position = 'initial';
            }
        };
    }
    handleBtnClick(value) {
        var _a;
        createCookie(this.cookieName, 1, value);
        this.show = false;
        this.setPageContentFixed(false);
        setScrollTop(this.scrollTop);
        if (value === 1)
            (_a = this.tabsContainer) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
    }
    showContent() {
        this.show = true;
        this.handlePopupOpen();
    }
    focusTrap() {
        const input = document.createElement('input');
        input.setAttribute('aria-disabled', 'true');
        input.setAttribute('aria-hidden', 'true');
        this.renderRoot.prepend(input);
        input.focus();
        input.setAttribute('disabled', 'true');
    }
    handlePopupOpen() {
        var _a;
        const tab = document.querySelector(`tab-item[tabid="${this.tabId}"]`);
        this.tabsContainer = tab === null || tab === void 0 ? void 0 : tab.parentNode;
        this.setPageContentFixed(true);
        if (this.hiddenBehindTabs)
            (_a = this.tabsContainer) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        window.OptanonWrapper = () => {
            const cookieBanner = document.querySelector('#onetrust-banner-sdk');
            if (cookieBanner) {
                const acceptBtn = cookieBanner.querySelector('#onetrust-accept-btn-handler');
                const refuseBtn = cookieBanner.querySelector('.ot-pc-refuse-all-handler');
                const saveBtn = cookieBanner.querySelector('.save-preference-btn-handler');
                acceptBtn === null || acceptBtn === void 0 ? void 0 : acceptBtn.addEventListener('click', () => this.focusTrap());
                refuseBtn === null || refuseBtn === void 0 ? void 0 : refuseBtn.addEventListener('click', () => this.focusTrap());
                saveBtn === null || saveBtn === void 0 ? void 0 : saveBtn.addEventListener('click', () => this.focusTrap());
            }
        };
        setTimeout(() => {
            if (this.show)
                this.focusTrap();
        }, 0);
    }
    firstUpdated() {
        setTimeout(() => {
            var _a;
            if (this.hiddenBehindTabs) {
                this.setPageContentFixed(false);
                (_a = this.tabsContainer) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
            }
        }, 1000);
        this.addEventListener('keydown', e => handleTabKey(e, this));
        if (!this.hiddenBehindTabs && !getCookie(this.cookieName))
            this.showContent();
    }
    render() {
        if (getCookie(this.cookieName) === '1')
            return null;
        if (getCookie(this.cookieName) === '0' && !this.hiddenBehindTabs) {
            window.location.href = this.redirectUrl;
            return null;
        }
        return x `<div class="modal-container ${this.show ? 'show' : ''}"><div class="modal"><slot name="heading"></slot><slot name="main-text"></slot><div class="cta-container"><slot name="primary-cta" @click="${() => this.handleBtnClick(1)}" @keypress="${(e) => {
            if (e.code !== 'Enter')
                this.handleBtnClick(1);
        }}"></slot><slot name="secondary-cta" @click="${() => this.handleBtnClick(0)}" @keypress="${(e) => {
            if (e.code !== 'Enter')
                this.handleBtnClick(0);
        }}"></slot></div></div></div>`;
    }
}
RestrictedContent.styles = css_248z;
__decorate([
    t()
], RestrictedContent.prototype, "show", void 0);
__decorate([
    t()
], RestrictedContent.prototype, "scrollTop", void 0);
__decorate([
    t()
], RestrictedContent.prototype, "tabsContainer", void 0);
__decorate([
    n()
], RestrictedContent.prototype, "cookieName", void 0);
__decorate([
    n()
], RestrictedContent.prototype, "redirectUrl", void 0);
__decorate([
    n()
], RestrictedContent.prototype, "tabId", void 0);
__decorate([
    n({ type: Boolean })
], RestrictedContent.prototype, "hiddenBehindTabs", void 0);
customElements.define('restricted-content', RestrictedContent);

export { RestrictedContent };
